var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { class: [{ "mh-treeMenu": true }, _vm.theme] },
    _vm._l(_vm.menuItems, function(item, index) {
      return _c(
        "MenuItem",
        {
          key: index,
          attrs: { item: item, "on-select": _vm.onSelect },
          scopedSlots: _vm._u(
            [
              _vm._l(_vm.$scopedSlots, function(_, name) {
                return {
                  key: name,
                  fn: function(slotData) {
                    return [_vm._t(name, null, null, slotData)]
                  }
                }
              })
            ],
            null,
            true
          )
        },
        [
          _vm._l(_vm.$slots, function(_, name) {
            return _vm._t(name, null, { slot: name })
          })
        ],
        2
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }